import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Checkbox } from '../../forms';
import queryString from 'query-string';
import classNames from 'classnames';
import { orderByCode } from './helpers';
import './chains.scss';
import './styles.scss';

class WrapCheckbox extends Component {
    
    state = {
        active: this.isActive()
    }

    isActive() {
        const qs = queryString.parse(this.props.location.search);

        if (this.props.defaultChecked) return true;

        if (!qs[this.props.childParam]) return false;
       
        let chainname = typeof qs[this.props.childParam] === 'string' ? [qs[this.props.childParam]] : qs[this.props.childParam];
        let isSelected = false;

        chainname.forEach(chain => {
            if (chain === this.props.label) {
                isSelected = true;
            }
        });

        return isSelected;
    }

    componentDidMount() {
        this.props.addComponent(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.setState({
                active: this.isActive()
            });

            return;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.active !== this.state.active || nextProps.count !== this.props.count;
    }

    toggleActive(active, doSearch) {

        if (this.props.count === 0 && !this.state.active) return;

        this.setState({
            active
        }, () => {
            if (doSearch !== false) {
                this.props.onChange();
            }
        });
    }
    
    render() {

        return (
            <label className={classNames({
                'facet-item': true,
                'facet-item--is-visible': this.props.count > 0,
                'facet-item--is-disabled': this.props.count === 0 && this.state.active
            })}>
                <Checkbox checked={this.state.active} onChange={() => this.toggleActive(!this.state.active)} name={this.props.name} value={this.props.value} />
                {this.props.children}
            </label>
        );
    }
}

class Chain extends Component {
    
    constructor(props) {
        super(props);
        this.subCheckBoxes = [];
        this.state = {
            isOpen: false,
            isSelected: this.isSelected()
        }
    }
    
    isSelected() {
        const qs = queryString.parse(this.props.location.search);
        return (qs[this.props.groupParam] === this.props.chain.label || this.props.defaultChecked) ? true : false;
    }

    addComponent(checkbox) {
        this.subCheckBoxes.push(checkbox);
    }

    toggleBrands() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    toggleSelectedSubBrands(e) {
        
        if (this.props.chain.count === 0 && this.state.isSelected) {
            return;
        }

        
        this.subCheckBoxes.forEach(chkBox => {
            chkBox.toggleActive(!this.state.isSelected, false);
        });

        this.setState({
            isSelected: !this.state.isSelected
        }, () => {
            this.props.submitForm();
        });
    }
    
    render() {

        const { chain, submitForm } = this.props;        
        if (chain.count === 0) return null;

        return (

            <div className="chains__group">
                <div className="chains__group-item">
                    <label className={classNames({
                            'facet-item': true,
                            'facet-item--is-visible': chain.count > 0,
                            'facet-item--is-disabled': chain.count === 0 && this.state.isSelected
                    })}>
                        <Checkbox onChange={(e) => this.toggleSelectedSubBrands(e)} name={this.props.groupParam} value={chain.label} checked={this.state.isSelected} /> <span>{chain.label}</span>
                    </label>
                    <button type="button" className={classNames({
                            'chains__toggle-btn': true,
                            'chains__toggle-btn--is-open': this.state.isOpen
                        })} onClick={() => this.toggleBrands()}><span>{this.state.isOpen ? 'Göm' : 'Visa'}</span></button>
                </div>
                
                {chain && chain.childrenFacetValues && 
                    <div className={classNames({
                        'chains__brands': true,
                        'chains__brands--is-open': this.state.isOpen
                    })}>
                        {orderByCode(chain.childrenFacetValues).map((brand, x) => {
                            return (
                                <div key={`${this.props.childParam}${brand.code}`} className="chains__brand">
                                    <WrapCheckbox {...brand} name={this.props.childParam} 
                                                             onChange={submitForm} 
                                                             addComponent={(ctrl) => this.addComponent(ctrl)} 
                                                             value={brand.label} 
                                                             location={this.props.location}
                                                             defaultChecked={this.props.defaultChecked}
                                                             childParam={this.props.childParam}> <><span>{brand.code} - {brand.label}</span><span className="facet-item__count">{brand.count}st</span></></WrapCheckbox>
                                </div>
                            );
                        })}
                    </div>
                }
            </div>
        );
    }
}

class Chains extends Component {
    state = {
        chainGroups: [{
            facetValues:[]
        }]
    };

    submitForm() {
        if (this.props.submitForm) {
            this.props.submitForm();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps && (prevProps.chainGroups !== this.props.chainGroups)) {
            
            const { chainGroups } = this.props;
            
            let currentTotal = [];
            chainGroups && chainGroups[0].facetValues.forEach(chain  => {
                currentTotal = [...currentTotal, ...chain.childrenFacetValues.filter(subChain => {
                    return subChain.count > 0;
                })];
            });
            
            let prevTotal = [];
             this.state.chainGroups[0].facetValues.forEach(chain  => {
                prevTotal = [...prevTotal, ...chain.childrenFacetValues.filter(subChain => {
                    return subChain.count > 0;
                })];
            });
            
            const hasMoreFacets = currentTotal.length > prevTotal.length;
            
            this.setState({
                chainGroups: hasMoreFacets || !this.props.isOpen ? this.props.chainGroups : this.state.chainGroups
            });
        }
    }
    
    render() {

        const { location, 
                groupParam, 
                childParam,
                defaultChecked } = this.props;

        if (this.state.chainGroups && this.state.chainGroups[0]) {
            return (
                <div className={classNames({
                    'chains': true,
                    ...this.props.modifiers
                })}>
                    {this.state.chainGroups[0].facetValues.map((chain, i) => {
                        return <Chain key={`chain${chain.label}`} 
                                      chain={chain} 
                                      location={location} 
                                      groupParam={groupParam} 
                                      childParam={childParam} 
                                      submitForm={() => this.submitForm()} 
                                      defaultChecked={defaultChecked} />
                    })}      
                </div>
            );
        }

        return null;
    }
};

export default withRouter(Chains);